import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";

// Layout Components
import Header from "./components/Header";
import ScrollButton from "./components/ScrollButton";
import Footer from "./components/Footer";
import ScrollToTop from "./ScrollToTop";
import HashScrollHandler from "./components/HashScrollHandler";

// Main Pages
import WhereWeWork from "./pages/WhereWeWork";
import ContactUs from "./pages/Contact";
import WhatDo from "./pages/What";
import Donors from "./pages/Donors";
import Partners from "./pages/Partners";
import Vision from "./pages/Vision";
import Donate from "./pages/Donate";
import Health from "./pages/Health";
import Education from "./pages/Education";
import Women from "./pages/Women";
import Freelancing from "./pages/Freelancing";
import DepartmentsPage from "./pages/DepartmentsPage";
import OnGoingProject from "./pages/OnGoingProject";
import ComingSoon from "./pages/ComingSoon";
import Reward from "./pages/Reward";

// Home Components
import Slider from "./components/Slider";
import About from "./components/About";
import Focus from "./components/Focus";
import Event from "./components/Event";
import Achievement from "./components/Achievement";
import ReadMoreEvent from "./components/ReadMoreEvent";
import SliderInfo from "./components/SliderInfo";
import DonorsSection from "./components/DonorsSection";

// Admin Components
import AdminLayout from "./admin/AdminLayout";
import DashboardHome from "./admin/pages/DashboardHome";
import FocusAreaList from "./admin/pages/focus-area/FocusAreaList";
import FocusAreaForm from "./admin/pages/focus-area/FocusAreaForm";
import SlideList from './admin/pages/slide/slideList';
import SlideForm from './admin/pages/slide/slideForm';
import EventList from './admin/pages/event/EventList';
import EventForm from './admin/pages/event/EventForm';
import PartnerList from './admin/pages/partner/PartnerList';
import PartnerForm from './admin/pages/partner/PartnerForm';
import DonorList from './admin/pages/donor/DonorList';
import DonorForm from './admin/pages/donor/DonorForm';
import DepartmentList from './admin/pages/department/DepartmentList';
import DepartmentForm from './admin/pages/department/DepartmentForm';
import Project from './components/Project';
import ReadMoreProject from './components/ReadMoreProject';

import ProjectList from '../src/admin/pages/project/ProjectList';
import ProjectForm from '../src/admin/pages/project/ProjectForm';
import AchievementList from './admin/pages/achievement/AchievementList';



import JobListPublic from './components/jobList';  // For public facing
import JobDetail from './components/jobDetail';    // For public facing
import JobListAdmin from './admin/pages/job/jobList';  // For admin
import JobForm from './admin/pages/job/jobForm';  // For admin


import AboutList from './admin/pages/about/AboutList';



// Login Page
import Login from './pages/Login';

// Services
import { focusAreaService } from "./admin/pages/focus-area/focusAreaService";
// import axios from 'axios';

// Styles
import "./index.css";
// import ProjectDetail from "./components/ProjectDetail";

// Create axios instance with credentials
// const api = axios.create({
//   baseURL: 'http://localhost:8000',
//   withCredentials: true,
// });

// Public Layout
const PublicLayout: React.FC = () => (
  <div id="page" className="site">
    <Header />
    <ScrollButton />
    <Outlet />
    <Footer />
  </div>
);

// Home Page
const HomePage: React.FC = () => (
  <>
    <Slider />
    <About />
    <Focus />
    <Achievement />
    <div className="home-page">
      <section id="events-section">
        <Event />
      </section>
    </div>
    <div id="projects-section">  {/* ← ADD THIS WRAPPER */}
      <Project />
    </div>
    <DonorsSection />
    
  </>
);

// Admin Routes Component - Fixed with all routes
// Admin Routes Component - Fixed with all routes
const AdminRoutes: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const user = localStorage.getItem('user');
    if (user) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AdminLayout>
      <Routes>
        {/* Dashboard */}
        <Route index element={<DashboardHome />} />
        
        {/* Focus Areas */}
        <Route path="home/focus-areas">
          <Route index element={<FocusAreaList />} />
          <Route path="create" element={<FocusAreaForm />} />
          <Route path="edit/:id" element={<FocusAreaForm isEdit />} />
        </Route>

        {/* Slides */}
        <Route path="home/slides">
          <Route index element={<SlideList />} />
          <Route path="create" element={<SlideForm />} />
          <Route path="edit/:id" element={<SlideForm isEdit />} />
        </Route>

        {/* Events */}
        <Route path="home/events">
          <Route index element={<EventList />} />
          <Route path="create" element={<EventForm />} />
          <Route path="edit/:id" element={<EventForm isEdit />} />
        </Route>

        {/* Projects - FIXED: Changed from "project" to "projects" */}
        <Route path="home/project">  
          <Route index element={<ProjectList />} />
          <Route path="create" element={<ProjectForm />} />
          <Route path="edit/:id" element={<ProjectForm isEdit />} />
        </Route>

        {/* Partners */}
        <Route path="partners">
          <Route index element={<PartnerList />} />
          <Route path="create" element={<PartnerForm />} />
          <Route path="edit/:id" element={<PartnerForm isEdit />} />
        </Route>

        {/* Donors */}
        <Route path="donors">
          <Route index element={<DonorList />} />
          <Route path="create" element={<DonorForm />} />
          <Route path="edit/:id" element={<DonorForm isEdit />} />
        </Route>

        {/* Achievements */}
        <Route path="home/achievements">
          <Route index element={<AchievementList />} />
        </Route>

        {/* Departments */}
        <Route path="departments">
          <Route index element={<DepartmentList />} />
          <Route path="create" element={<DepartmentForm />} />
          <Route path="edit/:id" element={<DepartmentForm isEdit />} />
        </Route>

        <Route path="home/jobs">
          <Route index element={<JobListAdmin />} />  {/* Use the admin version */}
          <Route path="create" element={<JobForm />} />
          <Route path="edit/:id" element={<JobForm isEdit />} />
        </Route>

        <Route path="home/about">
          <Route index element={<AboutList />} />
        </Route>


      </Routes>
    </AdminLayout>
  );
};

// Main App Component
const App: React.FC = () => {
  useEffect(() => {
    focusAreaService.initializeCsrf();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <HashScrollHandler />
      <Routes>
        {/* Public Login Route */}
        <Route path="/login" element={<Login />} />
        
        {/* Admin Routes - All admin pages are under this path */}
        <Route path="/admin/*" element={<AdminRoutes />} />

        {/* Public Routes */}
        // ========== PUBLIC ROUTES ==========
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<HomePage />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="where-we-work" element={<WhereWeWork />} />
        <Route path="what" element={<WhatDo />} />
        <Route path="vision" element={<Vision />} />
        <Route path="donate" element={<Donate />} />
        <Route path="partners" element={<Partners />} />
        <Route path="donors" element={<Donors />} />
        <Route path="about" element={<About />} />
        <Route path="health" element={<Health />} />
        <Route path="education" element={<Education />} />
        <Route path="women" element={<Women />} />
        <Route path="freelancing" element={<Freelancing />} />
        <Route path="departments" element={<DepartmentsPage />} />
        <Route path="OnGoingProject" element={<OnGoingProject />} />
        <Route path="ComingSoon" element={<ComingSoon />} />
        <Route path="Reward" element={<Reward />} />
        <Route path="event/:eventId" element={<ReadMoreEvent />} />
        <Route path="project/:projectId" element={<ReadMoreProject />} />
        <Route path="slider/:slideId" element={<SliderInfo />} />
        
          {/* ===== JOBS PUBLIC ROUTES ===== */}
        <Route path="jobs" element={<JobListPublic />} />
        <Route path="job/:id" element={<JobDetail />} />
        
              
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      </Routes>
    </Router>
  );
};

export default App;


















// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Header from "./components/Header";
// import ScrollButton from "./components/ScrollButton";
// import Footer from "./components/Footer";
// import WhereWeWork from "./pages/WhereWeWork";
// import ContactUs from "./pages/Contact";
// import WhatDo from "./pages/What";
// import PartnersSection from "./components/PartnersSection";
// import Donors from "./pages/Donors";
// import Partners from "./pages/Partners";
// import Slider from "./components/Slider";
// import About from "./components/About"; 
// import Vision from "./pages/Vision";
// import Focus from "./components/Focus";
// import Event from "./components/Event";
// import Achievement from "./components/Achievement";
// import ReadMoreEvent from './components/ReadMoreEvent'; 
// import SliderInfo from './components/SliderInfo'; 
// import Donate from './pages/Donate'; 
// import './index.css';
// import Health from "./pages/Health.js";
// import Education from "./pages/Education.js";
// import Women from "./pages/Women.js";
// import Freelancing from "./pages/Freelancing.js";
// import DepartmentsPage from "./pages/DepartmentsPage.js";
// // jobs folder
// import JobsMain from '/src/jobs/JobsMain.jsx';
// import JobsForm from '/src/jobs/components/JobsForm.jsx';
// import JobsHomePage from '/src/jobs/components/JobsHomePage.jsx';
// import CompaniesMainPage from '/src/jobs/CompaniesMainPage.jsx';// Make sure this import exists
// import ProcrumentPage from "/src/jobs/ProcurementPage.jsx";
// import ScrollToTop from "./ScrollToTop.tsx";

// import OnGoingProject from './pages/OnGoingProject';
// import HashScrollHandler from './components/HashScrollHandler.tsx'
// import ComingSoon from "./pages/ComingSoon.tsx";
// import Reward from "./pages/Reward.tsx";
// import './index.css'


// // Admin Components
// import AdminLayout from './admin/AdminLayout';

// import DashboardHome from './admin/pages/DashboardHome.tsx';

// import FocusAreaList from './admin/pages/focus-area/FocusAreaList';
// import FocusAreaForm from './admin/pages/focus-area/FocusAreaForm';





// const App: React.FC = () => {

//   return (
//     <Router>

//       <ScrollToTop /> 
//       <HashScrollHandler />
//       <div id="page" className="site">
//         <Header />
//         <ScrollButton />
//         <Routes>
//           <Route path="/" element={
//             <>
//               <Slider/>
//               <About/>
//               <Focus />




//           <Routes>
//           {/* Public Routes */}
//           <Route path="/" element={<div>Home Page</div>} />
//           <Route path="/focus-areas" element={<Focus />} />
          
//           {/* Admin Routes */}
//           <Route path="/admin" element={<AdminLayout />}>
//             <Route index element={<DashboardHome />} />
            
//             {/* Focus Areas */}
//             <Route path="home/focus-areas">
//               <Route index element={<FocusAreaList />} />
//               <Route path="create" element={<FocusAreaForm />} />
//               <Route path="edit/:id" element={<FocusAreaForm isEdit />} />
//             </Route>
            
//             {/* Other routes will be added here */}
//             <Route path="*" element={<Navigate to="/admin" replace />} />
//           </Route>
//         </Routes>




//               <Achievement />
//               <div className="home-page">
//                 <section id="events-section">
//                   <Event />
//                 </section>
//               </div>
//               <PartnersSection/>

//             </>
//           } />
//           <Route path="/contact" element={<ContactUs />} />
//           <Route path="/whereWeWork" element={<WhereWeWork />} />
//           <Route path="/what" element={<WhatDo />} />
//           <Route path="/vision" element={<Vision />} />
//           <Route path="/event/:eventId" element={<ReadMoreEvent />} />
//           <Route path="/slider/:slideId" element={<SliderInfo />} />
//           <Route path="/where-we-work" element={<WhereWeWork />} />
//           <Route path="/donate" element={<Donate/>} />
//           <Route path="/partners" element={<Partners/>} />
//           <Route path="/donors" element={<Donors/>} />
//           <Route path="/JobsForm" element={<JobsForm />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/health" element={<Health />} />
//           <Route path="/education" element={<Education />} />
//           <Route path="/women" element={<Women />} />
//           <Route path="/freelancing" element={<Freelancing />} />
//           <Route path="/departments" element={<DepartmentsPage />} />
//           <Route path="/OnGoingProject" element={<OnGoingProject />} />
//           <Route path="/ComingSoon" element={<ComingSoon />} />
//           <Route path="/Reward" element={<Reward />} />


         

//            {/* Jobs route with redirection */}
//         <Route path="/jobs" element={<JobsMain />}>
//           <Route index element={<Navigate to="JobsHomePage" replace />} />
//           <Route path="JobsHomePage" element={<JobsHomePage />} />
//           <Route path="companies" element={<CompaniesMainPage />} />
//           <Route path="procurement" element={<ProcrumentPage/>} />
//         </Route>
//         </Routes>
//         <Footer />
//       </div>
//     </Router>
//   );
// };

// export default App;